<template>
  <BModal
    active
    has-modal-card
    class="customer-bulk-upload"
    @close="() => $router.push({ name: 'Customers' })"
  >
    <form
      class="modal-card"
      @submit.prevent="create"
    >
      <header class="modal-card-head">
        <p class="modal-card-title has-text-primary">
          Carga masiva de clientes
        </p>
      </header>
      <section class="modal-card-body">
        <BField :class="{ 'has-background-primary': fileName }">
          <BUpload
            v-model="csv"
            accept=".csv"
            :disabled="loading"
            :loading="loading"
            multiple
            drag-drop
            @input="onInput('csv', $event)"
          >
            <section
              class="section"
            >
              <div
                class="content has-text-centered"
                :class="{ 'has-text-white': fileName }"
              >
                <p>
                  <BIcon
                    :icon="fileName ? 'check' : 'upload'"
                    size="is-large"
                  />
                </p>
                <p>
                  {{ fileName || 'Subir archivo' }}
                </p>
              </div>
            </section>
          </BUpload>
        </BField>

        <a
          class="button is-info is-fullwidth"
          href="/customers.csv"
          download="customers.csv"
          :class="{ 'is-loading': loading }"
          :disabled="loading"
        >
          <BIcon
            icon="cloud-download"
          />
          <span>
            Descargar ejemplo
          </span>
        </a>
      </section>
      <footer class="modal-card-foot">
        <RouterLink
          class="button"
          :to="{ name: 'Customers' }"
          :class="{ 'is-loading': loading }"
          :disabled="loading"
        >
          Cancelar
        </RouterLink>

        <button
          type="submit"
          class="button is-primary"
          :class="{ 'is-loading': loading }"
          :disabled="loading"
        >
          Subir clientes
        </Button>
      </footer>
    </form>
  </BModal>
</template>

<script>
export default {
  name: 'BulkUpload',
  data() {
    return {
      loading: false,
      csv: null,
      fileName: null,
    };
  },
  methods: {
    onInput(name, event) {
      const [file] = event;
      this.fileName = file.name;

      const reader = new FileReader();

      reader.onload = (e) => {
        const documentCsv = new Blob([e.target.result], { type: 'text/csv;charset=utf-8;' });

        this.$store.commit('customers/setValue', {
          accessor: name,
          value: documentCsv,
        });
      };

      reader.readAsText(file, 'ISO-8859-1');
    },

    async create(event) {
      event.stopPropagation();
      this.loading = true;
      try {
        await this.$store.dispatch('customers/bulkUpload');
        this.$router.push({ name: 'BulkLoadStatus' });
      } catch (error) {
        this.$danger({ message: error.message });
      }
      this.loading = false;
    },
  },
};
</script>

<style scoped>
@media screen and (min-width: 769px) {
  form {
    max-width: 400px;
  }
}
</style>

<style>
.customer-bulk-upload .upload-draggable.is-primary {
  width: 100%;
}
</style>
